import { motion } from 'framer-motion';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import Type from './Type';

export default function Banner() {
  const { ref: sectionRef, inView: isInView } = useInView({ threshold: 0.3 });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  

  return (
    <section
      ref={sectionRef}
      className="relative min-h-screen flex items-center justify-center px-4 py-16 md:px-8 lg:px-16 overflow-hidden"
      style={{
		    background: 'linear-gradient(180deg, rgb(3, 18, 35) 0%, rgb(4, 28, 56) 76.97%)',
      }}
    >
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <motion.div
          className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full bg-cyan-500 opacity-10 blur-3xl"
          animate={{
            scale: [1, 1.2, 1],
            opacity: [0.1, 0.15, 0.1]
          }}
          transition={{
            duration: 8,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
        <motion.div
          className="absolute bottom-1/3 right-1/4 w-80 h-80 rounded-full bg-purple-600 opacity-10 blur-3xl"
          animate={{
            scale: [1, 1.3, 1],
            opacity: [0.1, 0.2, 0.1]
          }}
          transition={{
            duration: 10,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 2
          }}
        />
      </div>

      <div className="relative z-10 w-full max-w-6xl text-left">
        {/* Name with subtle entrance animation */}
        <motion.h1
          className="text-2xl md:text-3xl font-medium text-gray-400 pb-2"
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          UVAIS KT
        </motion.h1>

        {/* Main headline with gradient and animation */}
        <motion.h2
          className="text-4xl md:text-6xl lg:text-7xl font-extrabold leading-tight py-4 bg-gradient-to-r from-cyan-400 via-blue-500 to-purple-600 bg-clip-text text-transparent"
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          FOUNDER OF NECTTOS
        </motion.h2>

        {/* Typing animation with fade-in */}
        <motion.div
          className="text-white font-bold text-3xl md:text-5xl lg:text-6xl pb-16 md:pb-24"
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <Type />
        </motion.div>

        {/* Animated scroll indicator */}
        <motion.div
          className="flex justify-center"
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.8, delay: 1.2 }}
        >
          <motion.div
            animate={{
              y: [0, 15, 0]
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          >
            <svg
              className="w-8 h-12 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect x="9" y="2" width="6" height="20" rx="3" strokeWidth="2"></rect>
              <line x1="12" y1="6" x2="12" y2="8" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}